var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    [
      _c("div", { class: _vm.itemClass, on: { click: _vm.toggle } }, [
        _vm.hasItems
          ? _c("span", {
              domProps: {
                innerHTML: _vm._s(_vm.open ? _vm.openedIcon : _vm.closedIcon)
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("span", { domProps: { innerHTML: _vm._s(_vm.item.name) } })
      ]),
      _vm._v(" "),
      _vm.hasItems
        ? _c("tree", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open"
              }
            ],
            tag: "ul",
            attrs: {
              items: _vm.item.items,
              "opened-html": _vm.openedHtml,
              "closed-html": _vm.closedHtml
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }